import _ from 'lodash';
import { notification } from 'antd';

export function showConfirmation(title, content) {
  const id = _.uniqueId();
  notification.success({
    message: title,
    description: content,
    key: id,
    onClick: () => {
      notification.close(id);
    },
    style: {
      cursor: 'pointer',
    },
    duration: 5,
  });
}

export function showError(title, content) {
  const id = _.uniqueId();
  notification.error({
    message: title,
    description: content,
    key: id,
    onClick: () => {
      notification.close(id);
    },
    style: {
      cursor: 'pointer',
    },
    duration: 5,
  });
}



// WEBPACK FOOTER //
// /src/services/notifications.js